import { Field, ObjectType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'

/**
 * GraphQL object type representing the metadata of a task action hook.
 * Used for exposing hook information through the GraphQL API.
 */
@ObjectType()
export class TaskActionHookType {
  /**
   * Unique identifier for the action hook.
   */
  @Field(() => String)
  id: string

  /**
   * Human-readable name for the action hook.
   */
  @Field(() => String)
  name: string

  /**
   * Description of what the action hook does.
   */
  @Field(() => String)
  description: string

  /**
   * Optional JSON Schema defining the parameters this hook accepts.
   */
  @Field(() => GraphQLJSON, { nullable: true })
  parameterSchema?: object
}
